import useTranslation from '@/utils/hooks/translation/useTranslation';

import type { ProfileType } from '@/components/pages/giveaway-picker/Types/types';

//Components
import { DefaultAvatar as Avatar } from '@/components/base/Avatar';
import { Select, SelectButton } from '@/components/base/Select/SelectComponent';

type OptionType = {
    value: string;
    label: string;
    profile: ProfileType;
};

type SelectButtonProps = Omit<
    React.ComponentProps<typeof SelectButton>,
    'selected' | 'children'
> & {
    selected?: OptionType;
};

function CustomSelectButton({ error, disabled, selected }: SelectButtonProps) {
    const { t } = useTranslation('giveaway_picker');
    return (
        <SelectButton selected={selected} disabled={disabled} error={error}>
            {selected?.profile ? (
                <div className="flex items-center gap-3">
                    <Avatar
                        url={selected?.profile?.avatar}
                        fallback={selected?.profile?.slug[0]}
                        size="md"
                    />
                    <span>{selected?.profile?.username}</span>
                </div>
            ) : (
                <div>{t('account_selection.select_account')}</div>
            )}
        </SelectButton>
    );
}
type OptionProps = { option: OptionType };
function CustomOption({ option }: OptionProps) {
    return (
        <div className="flex items-center gap-3">
            <Avatar size="md" url={option.profile?.avatar} fallback={option.profile?.slug[0]} />

            {option.label}
        </div>
    );
}

type SelectSocialProfileProps = {
    socialProfilesList: ProfileType[];
    selected: OptionType;
    setSelected: (selected: OptionType) => void;
};
export function SelectFreeTool({
    socialProfilesList,
    selected,
    setSelected
}: SelectSocialProfileProps) {
    const { t } = useTranslation('giveaway_picker');
    const options = socialProfilesList.map((profile: ProfileType) => ({
        value: profile.id.toString(),
        label: profile.slug,
        profile
    }));

    const initialSelected = selected || options[0] || null;

    return (
        <Select
            label={t('account_selection.insta_account')}
            setSelected={setSelected}
            selected={initialSelected}
            options={options}
            button={({ selected, ...props }) => CustomSelectButton({ selected, ...props })}>
            {({ option }) => <CustomOption option={option} />}
        </Select>
    );
}
